import { Link, RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
// routing
import router from 'routes';

// project imports
import Locales from 'ui-component/Locales';
import NavigationScroll from 'layout/NavigationScroll';
// import RTLLayout from 'ui-component/RTLLayout';
import Snackbar from 'ui-component/extended/Snackbar';
import ThemeCustomization from 'themes';
import Notistack from 'ui-component/third-party/Notistack';

// auth provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { Toaster } from 'react-hot-toast';

import UnderError from 'routes/Error';
// import { FirebaseProvider as AuthProvider } from 'contexts/FirebaseContext';
// import { AWSCognitoProvider as AuthProvider } from 'contexts/AWSCognitoContext';
// import { Auth0Provider as AuthProvider } from 'contexts/Auth0Context';

// ==============================|| APP ||============================== //

// ========================|| UNDER CONSTRUCTION PAGE ||======================== //

const App = () => (
    <ThemeCustomization>
        <Locales>
            <NavigationScroll>
                <AuthProvider>
                    <Sentry.ErrorBoundary fallback={() => <UnderError />}>
                        <Notistack>
                            <RouterProvider router={router} />
                            <Snackbar />
                            <Toaster />
                        </Notistack>
                    </Sentry.ErrorBoundary>
                </AuthProvider>
            </NavigationScroll>
        </Locales>
    </ThemeCustomization>
);

export default App;
